export default __webpack_public_path__ + "static/media/rishabh.0cb819bc.jpg";